/**
 *
 *@author zcc
 *@date 2022/3/4 13:16
 */
import { BaseServiceImpl } from '@/service/BaseServiceImpl';
import { AcountManageUrlConfig } from '@/config/AcountManageUrlConfig';

export class AcountManageServiceImpl extends BaseServiceImpl {
  private static service: AcountManageServiceImpl;

  public static getInstance(): AcountManageServiceImpl {
    if (AcountManageServiceImpl.service == null) {
      AcountManageServiceImpl.service = new AcountManageServiceImpl();
    }

    return AcountManageServiceImpl.service;
  }

  /**
   * 校验密码是否正确
   */
  checkPssword(id: string, password: string): Promise<any> {
    const option = BaseServiceImpl.getGetOption();
    option.url = AcountManageUrlConfig.checkPassword;
    option.params = {
      id: id,
      password: password
    };
    return new Promise((resolve, reject) => {
      this.huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  /**
   * 修改密码
   */
  modifyPassword(id: string, password: string): Promise<any> {
    const option = BaseServiceImpl.getPostOption();
    option.url = AcountManageUrlConfig.modifyPassword;
    option.data = {
      id: id,
      password: password
    };
    return new Promise((resolve, reject) => {
      this.huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
